"use client";

import { useEffect } from "react";
import { setupGlobalErrorHandlers } from "@/lib/error-reporting/setup-global-handlers";

export default function ErrorReporterInit() {
  useEffect(() => {
    setupGlobalErrorHandlers();
  }, []);
  return null;
}
